// extracted by mini-css-extract-plugin
export default {"root":"FriendListAddItem_root__HGfqv","addFriendImg":"FriendListAddItem_addFriendImg__F1Fbw","addFriend":"FriendListAddItem_addFriend__gz2iv"};